import { gql } from "@apollo/client";
import { BaseMutationTuple, jssaQuery, useBaseMutation } from "./index";
import { ShopifyProduct } from "../../../common/models";
import { shopifyProductAllFieldsFragment } from "./CommonQueries";
import { ShopifyProductsInput } from "../../../common/inputs/ShopifyProductsInput";

export const shopifyProductsForAdminQuery = gql`
    ${shopifyProductAllFieldsFragment}
    query shopifyProductsForAdmin($options: ShopifyProductsInput!) {
        shopifyProductsForAdmin(options: $options) {
            ...ShopifyProductAllFields
        }
    }
`;

export const shopifyProductByProductListingIdQuery = gql`
    ${shopifyProductAllFieldsFragment}
    query shopifyProductByProductListingId($productListingId: String!) {
        shopifyProductByProductListingId(productListingId: $productListingId) {
            ...ShopifyProductAllFields
        }
    }
`;

export const connectShopifyProductToStoreMutation = gql`
    ${shopifyProductAllFieldsFragment}
    mutation connectShopifyProductToStore($shopifyProductId: BigInt!, $storeId: String!) {
        connectShopifyProductToStore(shopifyProductId: $shopifyProductId, storeId: $storeId) {
            ...ShopifyProductAllFields
        }
    }
`;

export const queryShopifyProductsForAdmin = async (
    options: ShopifyProductsInput,
): Promise<ShopifyProduct[]> => {
    const { data: { shopifyProductsForAdmin } } = await jssaQuery<{ shopifyProductsForAdmin: ShopifyProduct[] }>({
        query: shopifyProductsForAdminQuery,
        variables: {
            options,
        },
    });
    return shopifyProductsForAdmin;
};

export const queryShopifyProductByProductListingId = async (
    productListingId: string,
): Promise<ShopifyProduct | null> => {
    const { data: { shopifyProductByProductListingId } } = await jssaQuery<{ shopifyProductByProductListingId: ShopifyProduct | null }>({
        query: shopifyProductByProductListingIdQuery,
        variables: {
            productListingId,
        },
    });
    return shopifyProductByProductListingId;
};

export const useConnectShopifyProductToStoreMutation = (): BaseMutationTuple<{ shopifyProductId: string; storeId: string }, ShopifyProduct> => {
    const transformInput = (input: { shopifyProductId: string; storeId: string }) => {
        return {
            shopifyProductId: input.shopifyProductId,
            storeId: input.storeId,
        };
    };

    const transformOutput = (output: any) => {
        return output.connectShopifyProductToStore;
    };

    return useBaseMutation<{ shopifyProductId: string; storeId: string }, ShopifyProduct>(
        connectShopifyProductToStoreMutation,
        transformInput,
        transformOutput,
    );
};
